var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfoCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.1634C8.27333 11.1634 8.5 10.9367 8.5 10.6634V7.33008C8.5 7.05674 8.27333 6.83008 8 6.83008C7.72667 6.83008 7.5 7.05674 7.5 7.33008V10.6634C7.5 10.9367 7.72667 11.1634 8 11.1634Z",
    fill: "#7A7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61301 5.2435C8.57967 5.1635 8.53301 5.09016 8.47301 5.0235C8.40634 4.9635 8.33301 4.91683 8.25301 4.8835C8.09301 4.81683 7.90634 4.81683 7.74634 4.8835C7.66634 4.91683 7.59301 4.9635 7.52634 5.0235C7.46634 5.09016 7.41967 5.1635 7.38634 5.2435C7.35301 5.3235 7.33301 5.41016 7.33301 5.49683C7.33301 5.5835 7.35301 5.67016 7.38634 5.75016C7.41967 5.83683 7.46634 5.9035 7.52634 5.97016C7.59301 6.03016 7.66634 6.07683 7.74634 6.11016C7.82634 6.1435 7.91301 6.1635 7.99967 6.1635C8.08634 6.1635 8.17301 6.1435 8.25301 6.11016C8.33301 6.07683 8.40634 6.03016 8.47301 5.97016C8.53301 5.9035 8.57967 5.83683 8.61301 5.75016C8.64634 5.67016 8.66634 5.5835 8.66634 5.49683C8.66634 5.41016 8.64634 5.3235 8.61301 5.2435Z",
    fill: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-info-circle.765b2f44ea6d6fc998f90fc234a254a9.svg";